import React, { FC } from 'react';
import { APP_STORE_URL, PLAY_STORE_URL } from 'data/appLinks';
import appStoreDark from 'images/app-badges/app-store-dark.svg';
import appStoreLight from 'images/app-badges/app-store-light.svg';
import googlePlayDark from 'images/app-badges/google-play-dark.svg';
import googlePlayLight from 'images/app-badges/google-play-light.svg';

export interface AppStoreButtonsProps {
    className?: string;
    /** "dark" renders the black badges (for light backgrounds), "light" the white badges (for dark backgrounds). */
    theme?: 'dark' | 'light';
    /** Tailwind height utilities applied to the badge images. */
    sizeClass?: string;
}

const AppStoreButtons: FC<AppStoreButtonsProps> = ({ className = '', theme = 'dark', sizeClass = 'h-10 sm:h-12' }) => {
    const appStoreBadge = theme === 'dark' ? appStoreDark : appStoreLight;
    const googlePlayBadge = theme === 'dark' ? googlePlayDark : googlePlayLight;

    const renderBadge = (href: string, src: string, alt: string) => (
        <a href={href} target="_blank" rel="noopener noreferrer" className="inline-block transition-opacity hover:opacity-80">
            <img src={src} alt={alt} className={`${sizeClass} w-auto`} />
        </a>
    );

    return (
        <div className={`nc-AppStoreButtons flex flex-wrap items-center gap-3 ${className}`}>
            {renderBadge(APP_STORE_URL, appStoreBadge, 'Download INSTAACARD on the App Store')}
            {renderBadge(PLAY_STORE_URL, googlePlayBadge, 'Get INSTAACARD on Google Play')}
        </div>
    );
};

export default AppStoreButtons;
